import moment from 'moment-timezone';
import qs from 'qs';
import {
  PROJECT_UNIT_SPECIFICATIONS_REQUEST,
  PROJECT_UNIT_SPECIFICATIONS_FAILURE,
  PROJECT_UNIT_SPECIFICATIONS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function projectUnitSpecificationsRequest() {
  return {
    type: PROJECT_UNIT_SPECIFICATIONS_REQUEST,
  };
}

function projectUnitSpecificationsSuccess(data, token = null) {
  return {
    type: PROJECT_UNIT_SPECIFICATIONS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function projectUnitSpecificationsError(message) {
  return {
    type: PROJECT_UNIT_SPECIFICATIONS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchProjectUnitSpecifications(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(projectUnitSpecificationsRequest());
    if (!fresh) {
      let projectUnitSpecificationsData = {};
      try {
        projectUnitSpecificationsData = JSON.parse(getItem(`${config.get('appName')}.projectUnitSpecifications`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !projectUnitSpecificationsData.data ||
        config.get('version') !== projectUnitSpecificationsData.version ||
        moment().isAfter(moment(projectUnitSpecificationsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectUnitSpecificationsSuccess(projectUnitSpecificationsData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
    });
    return dispatch(fetchM(`/specifications/units/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.projectUnitSpecifications`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(projectUnitSpecificationsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, projectUnitSpecificationsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/projectUnitSpecifications.js